import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import { formatUrlForDisplay } from "@/lib/utils";
import { X } from "lucide-react";

interface SelectedWorkspaceProps {
  selectedLink: string;
  onRemove: () => void;
  onRemoveWithDropdown: () => void;
}

export function SelectedWorkspace({
  selectedLink,
  onRemoveWithDropdown,
}: SelectedWorkspaceProps) {
  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <Badge
          variant="secondary"
          className="px-2 py-1 gap-2 flex items-center max-w-[260px] sm:max-w-[400px] truncate z-20 ml-1"
        >
          <span className="truncate">{formatUrlForDisplay(selectedLink)}</span>
          <Button
            variant="ghost"
            size="sm"
            className="h-5 w-5 p-0 hover:bg-muted rounded-full flex-shrink-0 ml-1"
            onClick={onRemoveWithDropdown}
          >
            <X className="h-3 w-3" />
            <span className="sr-only">Remove</span>
          </Button>
        </Badge>
      </HoverCardTrigger>
      <HoverCardContent className="w-auto p-2 text-sm">
        {selectedLink}
      </HoverCardContent>
    </HoverCard>
  );
}
